var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketVoucher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 44",
    width: 45,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ticket-voucher") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.98-4l28.98 29.45-22.21 21.85-28.98-29.45z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #003a4f } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "color5Fill",
    d: "m24.7 0.9c1-0.5 2.2-0.2 2.8 0.8l17.1 27.9c0.6 1 0.2 2.2-0.8 2.7l-5.2 3c-0.4 0.2-0.8 0.1-1-0.2-0.9-1.6-2.9-2.2-4.6-1.3-1.5 0.9-2.1 2.7-1.4 4.3q0.2 0.3 0 0.7 0 0-0.1 0.1l-4.1 4.1c-0.8 0.8-2.1 0.8-2.9 0l-23.3-23.7c-0.8-0.8-0.8-2.1 0-2.9l3.9-3.8c0.3-0.2 0.7-0.2 0.9 0 1.4 1.4 3.5 1.4 4.8 0.1 1.4-1.3 1.4-3.5 0.1-4.8-0.3-0.3-0.3-0.7 0-1l2.9-2.8c0.2-0.3 0.7-0.3 0.9 0 0.3 0.2 0.3 0.7 0 0.9l-2.4 2.4c1.4 1.9 1.2 4.6-0.5 6.2-1.7 1.7-4.4 1.8-6.2 0.4l-3.4 3.4c-0.3 0.2-0.3 0.7 0 0.9l23.2 23.7c0.3 0.3 0.7 0.3 1 0l3.4-3.4c-1.4-1.8-1.2-4.5 0.5-6.1 1.7-1.7 4.4-1.8 6.2-0.4l3.4-3.4c0.3-0.3 0.3-0.7 0-1l-21.8-22.1c-0.3-0.4-0.2-0.9 0.2-1.1l6.4-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "color5Fill",
    d: "m24.4 18.8l1.1-0.8c0.1 0 0.2 0.1 0.1 0.2l-0.7 1c-1.6 2.2-1.6 5.1-0.1 7.2l0.8 1.1c0.1 0.1-0.1 0.2-0.2 0.1l-1-0.7c-2.2-1.6-5.1-1.6-7.2-0.1l-1.1 0.8c-0.1 0-0.2-0.1-0.1-0.2l0.7-1c1.6-2.2 1.6-5.1 0.1-7.2l-0.8-1.1c0-0.1 0.1-0.2 0.2-0.1l1 0.7c2.2 1.6 5.1 1.6 7.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "color5Fill",
    d: "m19.5 10.8c0.2 0.3 0.7 0.3 0.9 0 0.3-0.2 0.3-0.7 0-0.9-0.2-0.3-0.7-0.3-0.9 0-0.3 0.2-0.3 0.7 0 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "color5Fill",
    d: "m17.5 13.7c-0.2 0.2-0.7 0.2-0.9 0-0.3-0.3-0.3-0.7 0-1 0.2-0.2 0.7-0.2 0.9 0 0.3 0.3 0.3 0.7 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "color5Fill",
    d: "m14.6 16.5c-0.2 0.3-0.7 0.3-0.9 0-0.3-0.2-0.3-0.7 0-0.9 0.2-0.3 0.7-0.3 0.9 0 0.3 0.2 0.3 0.7 0 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "color5Fill",
    d: "m8.8 22.2c-0.2 0.3-0.7 0.3-0.9 0-0.3-0.2-0.3-0.7 0-0.9 0.3-0.3 0.7-0.3 0.9 0 0.3 0.2 0.3 0.7 0 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "color5Fill",
    d: "m11.7 19.4c-0.2 0.2-0.7 0.2-0.9 0-0.3-0.3-0.3-0.7 0-1 0.2-0.2 0.7-0.2 0.9 0 0.3 0.3 0.3 0.7 0 1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketVoucher);
export default __webpack_public_path__ + "static/media/ticket-voucher.584357f7e295d8ae43014433c4260a5d.svg";
export { ForwardRef as ReactComponent };